import { defineStore } from 'pinia'

export const useSidebarStore = defineStore('sidebar', {
  state: () => ({
    isShrinked: localStorage.getItem('sidebarShrink') === 'true',
  }),
  actions: {
    toggleShrink() {
      this.isShrinked = !this.isShrinked
      localStorage.setItem('sidebarShrink', this.isShrinked.toString())
    },
    setShrinked(val) {
      this.isShrinked = val
      localStorage.setItem('sidebarShrink', val.toString())
    },
  },
})